// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3ejfy","approved":"Status_approved__Z07eA","rejected":"Status_rejected__3Q0mj","expired":"Status_expired__L2AS7","label":"Status_label__28CkU"};